import axios from 'axios';
// import setAuthToken from '../utils/setAuthToken';
import jwt_decode from 'jwt-decode';

import { 
  GET_ERRORS, 
  EDIT_USER_SUCCESS,
  GET_ALL_USER_SUCCESS,
  DELETE_USER_SUCCESS
   } from './types';
import { toast } from 'react-toastify';

// Register User
export const editUser = (userData) => dispatch => {
  axios
    .post('/api/users/register', userData)
    .then(res => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: res.data
      })
      toast.success('User register success.');
    })
    .catch(err =>
      {
        toast.error(`${err.response.data.message}`);
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data
        })
    }
    );
};

export const getAllUsers = () => dispatch => {
  axios
    .get('/api/users')
    .then(res => {
        console.log(res);
        dispatch({
          type: GET_ALL_USER_SUCCESS,
          payload: res.data
        })
      }
    )
    .catch(err => {
        // console.log(err.response.data);
      }
    );
};

export const updateRole = (data) => {
  return axios.post('/api/users/update_role', data);
}

export const deleteUser = (id) => {
  return axios.delete(`/api/users/${id}`);
    // .then(res => {
    //     console.log(res);
    //     getAllUsers();
    //   }
    // )
    // .catch(err => {
    //     // console.log(err.response.data);
    //   }
    // );
};

